import { Form } from "@circle-react-uikit/Form";

import { t } from "@/i18n-js/instance";
import { useCanMarkPurchaseFlow } from "@/react/helpers/purchaseFlowAnchor";

interface MayLeadToPurchaseFieldProps {
  className?: string;
  name?: string;
}

export const MayLeadToPurchaseField = ({
  className,
  name = "mayLeadToPurchase",
}: MayLeadToPurchaseFieldProps) => {
  const canMarkPurchaseFlow = useCanMarkPurchaseFlow();

  if (!canMarkPurchaseFlow) return null;

  return (
    <Form.Checkbox
      name={name}
      className={className}
      label={t("builder_ui.prop_type.may_lead_to_purchase")}
      description={t("builder_ui.prop_type.may_lead_to_purchase_description")}
    />
  );
};
